
import { BaseBackgroundEffectType } from '@/types';
import { BackgroundEffect, BackgroundContext } from './BackgroundEffect';

export class BackgroundRegistry {
    private static effects: Map<BaseBackgroundEffectType, BackgroundEffect> = new Map();

    public static register(type: BaseBackgroundEffectType, effect: BackgroundEffect) {
        this.effects.set(type, effect);
    }

    public static render(type: BaseBackgroundEffectType, bc: BackgroundContext) {
        const effect = this.effects.get(type);
        if (effect) {
            effect.render(bc);
        } else {
            // Fallback to clear
            bc.ctx.fillStyle = bc.config.darkMode ? '#000000' : '#ffffff';
            bc.ctx.fillRect(0, 0, bc.width, bc.height);
        }
    }
}
